const schema = (vehicleTypes) => ({
  type: 'object',
  required: [],
  properties: {
    owner_id: {
      type: 'string',
      title: 'owner',
    },
    driver_id: {
      type: 'string',
      title: 'driver',
    },
    type_id: {
      type: 'string',
      title: 'vehicle_type',
      default: undefined,
      oneOf: vehicleTypes,
    },
    serial_number: {
      type: 'string',
      title: 'serialNumber',
    },
    plaque: {
      type: 'object',
      title: 'پلاک',
      required: ['two_left_digits_plate', 'three_right_digits_plate'],
      properties: {
        two_left_digits_plate: {
          type: 'string',
        },
        three_right_digits_plate: {
          type: 'string',
        },
      },
    },
    details: {
      type: 'string',
      title: 'details',
    },
  },
});

export default schema;
